import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import React from "react";
const classes = {
  timeLabelCell: "tw-timeLabelCell",
  timeSlotCell: "tw-timeSlotCell",
  container: "tw-container",
  disabled: "tw-disabled",
  selected: "tw-selected"
};
interface SlotComponentProps {
  className?: string;
  slotValue?: unknown;
  [key: string]: unknown;
}
interface TimeSlotWrapperProps {
  children: React.ReactNode;
  CustomSlotComponent?: React.ComponentType<SlotComponentProps>;
  slotClasses: {
    root?: string;
  };
  value?: unknown;
  disabled?: boolean;
  selected?: boolean;
  visitAvailability?: boolean;
  timeLabelTextFunc?: (timeLabelText: string) => string;
}
export default function TimeSlotWrapper(t0) {
  const $ = _c(13);
  const {
    children,
    CustomSlotComponent,
    slotClasses,
    value,
    disabled,
    selected,
    timeLabelTextFunc
  } = t0;
  const slotStatusClassName = selected ? classes.selected : disabled ? classes.disabled : classes.container;
  const isReactElementWithProps = _temp;
  const t1 = isReactElementWithProps(children) ? children.props.className : "px-2";
  let t2;
  if ($[0] !== t1) {
    t2 = clsx("w-full", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== CustomSlotComponent || $[3] !== children || $[4] !== disabled || $[5] !== slotClasses || $[6] !== slotStatusClassName || $[7] !== timeLabelTextFunc || $[8] !== value) {
    t3 = isReactElementWithProps(children) ? timeLabelTextFunc ? <div className={clsx("h-full font-thin text-sm text-gray-700 flex items-center justify-start pr-1", children.props.className)}>{timeLabelTextFunc(children.props.children.props.children)}</div> : <div className={clsx("h-full font-thin text-sm text-gray-700 flex items-center justify-start pr-1", children.props.className)}>{children.props.children}</div> : CustomSlotComponent ? <div className={CustomSlotComponent && slotClasses.root ? disabled ? "bg-gray-200/10 rounded-full flex-[0.95] h-[95%] overflow-hidden" : "bg-gray-200/40 rounded-full flex-[0.95] h-[95%] overflow-hidden" : slotStatusClassName}><CustomSlotComponent className={slotClasses.root ? slotClasses.root : slotStatusClassName} slotValue={value} data-testid="time-slot-wrapper" /></div> : <div className={CustomSlotComponent && slotClasses.root ? "bg-gray-200/40 rounded-full flex-[0.95] h-[95%] overflow-hidden" : slotStatusClassName}>{children}</div>;
    $[2] = CustomSlotComponent;
    $[3] = children;
    $[4] = disabled;
    $[5] = slotClasses;
    $[6] = slotStatusClassName;
    $[7] = timeLabelTextFunc;
    $[8] = value;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function _temp(children_0) {
  return React.isValidElement(children_0) && typeof (children_0.props as {
    children?: {
      props?: {
        children?: unknown;
      };
    };
  })?.children?.props?.children === "string";
}